export class LayaGL {
}
